import { Flex } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Input, Modal, Toggle } from '@feathr/components';
import { cssVar } from '@feathr/hooks';

import { useModals } from '../Locations.useModals';
import SaveChangesModal from '../SaveChangesModal';

import * as styles from './GeoFilterModal.css';

type TModalContext = 'create' | 'edit';

interface IGeoFilterModalProps {
  opened: boolean;
  onClose: () => void;
  context?: TModalContext;
  onSaveChanges?: () => void;
}

function GeoFilterModal({
  opened: isModalOpen,
  onClose: closeModal,
  context = 'create',
  onSaveChanges,
}: Readonly<IGeoFilterModalProps>): JSX.Element {
  const { t } = useTranslation();

  const { saveChanges } = useModals();

  const handleApply = (): void => {
    if (context === 'edit') {
      saveChanges.open();
    } else {
      closeModal();
    }
  };

  const handleSaveChangesSubmit = (): void => {
    // TODO: Implement actual save changes logic
    // eslint-disable-next-line no-console
    console.log('Save changes confirmed');

    // Call the parent's callback if provided
    if (onSaveChanges) {
      onSaveChanges();
    }

    saveChanges.close();
    closeModal();
  };

  return (
    <Modal
      bodyClassName={styles.body}
      description={t('{{count}} locations remaining.', { count: 50 })}
      leftActions={[
        <Button key={'add-location'} onClick={closeModal}>
          {t('Add location')}
        </Button>,
      ]}
      onClose={closeModal}
      opened={isModalOpen}
      rightActions={[
        <Button key={'cancel'} onClick={closeModal}>
          {t('Cancel')}
        </Button>,
        <Button key={'save'} onClick={handleApply}>
          {t('{{context}}', {
            context: context === 'create' ? t('Save') : t('Apply'),
          })}
        </Button>,
      ]}
      size={'lg'}
      title={t('{{context}} GeoFilter Set', {
        context: context === 'create' ? t('Create') : t('Edit'),
      })}
    >
      <Flex direction={'column'} gap={cssVar('--spacing-2')} w={'100%'}>
        <Input label={t('Geofilter set name')} placeholder={t('Geofilter set name')} />
        <Toggle
          color={'slate'}
          defaultChecked={false}
          label={t('Assign as default set')}
          layout={'well'}
        />
      </Flex>

      {context === 'edit' && (
        <SaveChangesModal
          onClose={saveChanges.close}
          onSaveAndClose={handleSaveChangesSubmit}
          opened={saveChanges.isOpen}
        />
      )}
    </Modal>
  );
}

export default GeoFilterModal;
